import * as React from 'react';
import { TerminalRemote } from 'services/clients/terminal';

interface Props {
  terminal: TerminalRemote;
  classes: Record<string, string>;
}

export const CheckSystemCell: React.FC<Props> = (props) => {
  const { classes, terminal } = props;
  return (
    <a
      className={classes.checkTerminalPortalHeader}
      href={terminal.terminal_portal}
      target="_blank"
      rel="noopener noreferrer"
    >
      Check {terminal.appointment_system_name} portal
    </a>
  );
};
CheckSystemCell.displayName = 'Cell.CheckSystemCell';
